// src/store/actions/authActions.js
import {createAction} from '@reduxjs/toolkit';

export const logoutAction = createAction('auth/logout');
export const loginAction = createAction('auth/login');

// signifies that authz was loaded, or, reloaded.
export const userAuthzLoaded = createAction<string>('user/authzLoaded');
